export const SET_SETUP = "SET_SETUP";
export const RESET_SETUP = "RESET_SETUP";
export const SET_COUPON_IMAGES = "SET_COUPON_IMAGES";
export const SET_BANNER_IMAGES = "SET_BANNER_IMAGES";
